import React from 'react';
import './DeletePostButton.css';
import { ReactComponent as DeletePostIcon } from './remove-post-icon.svg';

export const DeletePostButton = ({ onDeletePost }) => {
    return (
        <div className="accept delete-post-button" onClick={() => onDeletePost()}>
            <DeletePostIcon />
        </div>
    );
};
